import clsx from 'clsx';
import { useParams } from 'next/navigation';
import { useState } from 'react';

import { Icon, Link, Typography } from '@/components/core';
import { NavigationLinkStoryblok, SubMenuStoryblok } from '@/types/storyblok/storyblok-types';
import { parseStoryblokLinkObject } from '@/utils/storyblok';

import styles from './Submenu.module.scss';

type SubmenuProps = {
    blok: SubMenuStoryblok | NavigationLinkStoryblok;
    level: number;
    isNested?: boolean;
    openMenus?: string[];
    toggleMenuVisibility: (prevId: string, level: number) => void;
    avoidAutoUnderline?: boolean;
};
export const SubmenuDesktop: React.FC<SubmenuProps> = ({
    blok,
    level,
    isNested,
    openMenus,
    toggleMenuVisibility,
    avoidAutoUnderline,
}) => {
    const [hovered, setHovered] = useState<boolean>(false);
    const params = useParams();
    const mouseEnterLink = () => {
        setHovered(true);
        if (level === 0) {
            toggleMenuVisibility('initial', 1);
        }
    };

    // const mouseEnterHandler = () => {
    //     setHovered(true);
    //     if (openMenus[1] === blok._uid) return;
    //     if (level === 0) {
    //         toggleMenuVisibility(blok._uid, 1);
    //     }
    // };

    const mouseLeaveHandler = () => {
        setHovered(false);

        if (level === 0 && openMenus[1] !== blok._uid) {
            toggleMenuVisibility('initial', 1);
        }
    };

    const renderSubMenu = (menuBlok: SubMenuStoryblok) => {
        const { subMenu } = menuBlok;
        const isActive = openMenus?.[level + 1] === menuBlok._uid;

        return (
            <div
                className={clsx(styles.root, styles.subMenu, {
                    [styles.isNested]: isNested,
                    [styles.isActive]: isActive,
                    [styles.underlined]: hovered && !isNested,
                })}
                onMouseLeave={mouseLeaveHandler}
            >
                <div
                    className={styles.buttonItem}
                    onClick={() => toggleMenuVisibility(menuBlok._uid, level + 1)}
                    // onMouseEnter={mouseEnterHandler}
                >
                    <Typography
                        looksLike="menu"
                        className={clsx(styles.title, {
                            [styles.active]: isActive,
                        })}
                    >
                        {menuBlok.title}
                    </Typography>
                    <Icon
                        name="chevron"
                        className={clsx(styles.arrow, {
                            [styles.rotate]: openMenus?.[level + 1] === menuBlok._uid,
                        })}
                    />
                </div>

                <div className={clsx(styles.innerMenuWrapper)}>
                    {subMenu?.map(link => {
                        const { _uid: uid } = link;
                        return (
                            <div
                                key={uid}
                                className={clsx(styles.innerMenu)}
                            >
                                <SubmenuDesktop
                                    openMenus={openMenus}
                                    toggleMenuVisibility={toggleMenuVisibility}
                                    level={level + 1}
                                    isNested
                                    blok={link}
                                    key={uid}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    const renderNavigationLink = (linkBlok: NavigationLinkStoryblok) => (
        <Link
            href={parseStoryblokLinkObject(linkBlok.link)}
            target={linkBlok.link.target}
        >
            <div
                onMouseEnter={mouseEnterLink}
                onMouseLeave={() => setHovered(false)}
                className={clsx(styles.navigationRoot, {
                    [styles.activeLink]:
                        (`${params?.lang}/${params?.slug?.[0]}` === blok?.link!.cached_url && !avoidAutoUnderline) ||
                        // && openMenus.length < 2
                        (hovered && !isNested),
                })}
            >
                <Typography looksLike="menu">{linkBlok.title}</Typography>
            </div>
        </Link>
    );

    switch (blok.component) {
        case 'navigationLink':
            return renderNavigationLink(blok);
        default:
            return renderSubMenu(blok);
    }
};
